require('./css/jquery.loader.css');
require('./img/jquery.loader.gif');
require('./js/jquery.loader.js');



// WEBPACK FOOTER //
// ./plugins/jquery.loader/require.js